import { PayloadAction } from '@reduxjs/toolkit';

import { AddendumItem } from '@hcs/types';
import { createHcReduxSlice } from '@hcs/utils';

export interface AddendumSliceState {
  addendumList: AddendumItem[];
}

export interface AddendumPartialAppState {
  addendumSlice: AddendumSliceState;
}

const initialState: AddendumSliceState = {
  addendumList: [],
};

export const addendumSlice = createHcReduxSlice({
  name: 'addendumSlice',
  initialState,
  reducers: {
    addItemToAddendumList(
      state,
      action: PayloadAction<{
        term?: AddendumItem['term'];
        description: AddendumItem['description'];
        source: AddendumItem['source'];
        page: AddendumItem['page'];
      }>,
    ) {
      if (
        state?.addendumList &&
        state.addendumList.findIndex(
          (f) => f.description === action.payload.description,
        ) === -1
      ) {
        state.addendumList.push({
          term: action.payload?.term,
          description: action.payload.description,
          source: action.payload.source,
          page: action.payload.page,
        });
      }
    },
    clearList(state) {
      state.addendumList = initialState.addendumList;
    },
  },
});
